import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
var clickWatchAction = createAction("".concat(actionTypePrefix, "/CLICK_WATCH"), function (user, isWatching, onToggleWatchSuccess) { return ({
    user: user,
    isWatching: isWatching,
    onToggleWatchSuccess: onToggleWatchSuccess,
}); });
// TS shenanigans...
export var clickWatch = clickWatchAction;
export var requestSuccess = createAction("".concat(actionTypePrefix, "/REQUEST_SUCCESS"), function (username, isWatching) { return ({
    username: username,
    isWatching: isWatching,
}); });
export var requestFailure = createAction("".concat(actionTypePrefix, "/REQUEST_FAILURE"), function (username, error) { return ({
    username: username,
    error: error,
}); });
export var setWatchingState = createAction("".concat(actionTypePrefix, "/SET_WATCHING_STATE"), function (username, isWatching) { return ({ username: username, isWatching: isWatching }); });
//# sourceMappingURL=actionCreators.js.map